export const MODULE_NAME = 'lk-mun-meh-form-review'

export const LK_MUN_MEH_FORM_REVIEW_ROUTES = {
  LAYOUT: MODULE_NAME,
  FORM: `${MODULE_NAME}.review.form`,
  ANY_LEVEL: `${MODULE_NAME}.form.level`,
} as const
